<script>
import CalendarApp from '../calendar/App.vue';
import CalendarMiniApp from '../calendar-mini/App.vue';

export default {
    name: 'CalendarDesktopApp',
    components: { CalendarMiniApp, CalendarApp },
    data() {
        return {
            isDesktop: true,
            mobileBreakpoint: 1024
        };
    },
    mounted() {
        this.checkBreakpoint();
        window.addEventListener('resize', this.checkBreakpoint.bind(this), {
            passive: true
        });
    },

    methods: {
        checkBreakpoint() {
            this.isDesktop = window.innerWidth > this.mobileBreakpoint;
        }
    }
};
</script>

<template>
    <div>
        <template v-if="isDesktop">
            <CalendarApp />
        </template>
        <template v-else>
            <CalendarMiniApp />
        </template>
    </div>
</template>
